import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { actions } from '../../redux/modules/jobs'
import { actions as vendorActions } from '../../redux/modules/jobFunctions/jobVendorActions'
import JobInvoices from '../job/tasks/JobInvoices'

const propTypes = {}

class InvoicesContainer extends Component {
  render() {
    return (
      <JobInvoices {...this.props} fromDashboard={true} user={this.props.authentication.user} />
    )
  }
}

const mapStateToProps = ({ jobs, jobVendorActions, authentication }, ownProps) => ({
  jobs,
  jobVendorActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, vendorActions), dispatch)
})

InvoicesContainer.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InvoicesContainer))



// WEBPACK FOOTER //
// ./src/containers/dashboard/InvoicesContainer.js